import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import LinkBack from '../widgets/LinkBack';
import Typography from '../widgets/Typography/Typography';

import './analytical-coverage.scss';
import BlockInfo from '../widgets/Typography/BlockInfo';
import BlockLink from '../widgets/Typography/BlockLink';
import BlockImage from '../widgets/Typography/BlockImage';

class AnalyticalCoverageTemplate extends PureComponent {
  render() {
    return (
      <div className="analytical-coverage">
        {(this.props.content.meta) &&
          <Helmet>
            <title>{this.props.content.meta.title}</title>
          </Helmet>
        }

        <div className="container">
          <div className="analytical-coverage-content">
            <LinkBack link="/analyze/subnavigation/">
              анализируем <i>вернуться</i>
            </LinkBack>

            <Typography content={this.props.content.content} />
          </div>

          <div className="analytical-coverage-panel">
            {(!!this.props.content.image) &&
              <BlockImage content={this.props.content.image} />
            }
            {(!!this.props.content.info) &&
              <BlockInfo content={this.props.content.info} />
            }
            {(!!this.props.content.link) &&
              <BlockLink content={this.props.content.link} />
            }
          </div>
        </div>
      </div>
    );
  }
}

AnalyticalCoverageTemplate.propTypes = {
  content: PropTypes.shape({
    meta: PropTypes.shape({
      title: PropTypes.string
    }),
    content: PropTypes.arrayOf(PropTypes.object),
    info: PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string
    }),
    link: PropTypes.shape({
      title: PropTypes.string,
      link: PropTypes.string,
      label: PropTypes.string
    })
  })
};

export default AnalyticalCoverageTemplate;



// WEBPACK FOOTER //
// ./src/components/AnalyticalCoverage/AnalyticalCoverageTemplate.js